import { Features } from 'generated/featureDefinitions'
import { ProjectLogDocument } from 'generated/resources/graphql'

import { ActivityLogSidepanel } from 'modules/core/components/ActivityLog/ActivityLogSidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { MissingFeatureEmptyState } from 'modules/project_management/components/upsells/MissingFeatureEmptyState'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

const IDENTIFIER = 'projects'

const SOURCE_OPTIONS = () => {
  return {
    assigments: {
      key: 'project_assignment_source',
      title: i18n.t('project_management.project_log.filters.assignments'),
    },
    unassigments: {
      key: 'project_unassignment_source',
      title: i18n.t('project_management.project_log.filters.unassignments'),
    },
    time_records: {
      key: 'time_record_created_source',
      title: i18n.t('project_management.project_log.filters.time_record'),
    },
    financial_details: {
      key: 'project_update_financial_details_source',
      title: i18n.t('project_management.project_log.filters.fixed_costs'),
    },
    expenses: {
      key: 'expense_record_created_source',
      title: i18n.t('project_management.project_log.filters.expenses'),
    },
    subproject_created: {
      key: 'subproject_created_source',
      title: i18n.t('project_management.project_log.filters.subproject_created'),
    },
    subproject_renamed: {
      key: 'subproject_renamed_source',
      title: i18n.t('project_management.project_log.filters.subproject_renamed'),
    },
    subproject_deleted: {
      key: 'subproject_deleted_source',
      title: i18n.t('project_management.project_log.filters.subproject_deleted'),
    },
  }
}

interface Props {
  id: number
  name: string
  onClose: () => void
}

export const ProjectLog = ({ id, name, onClose }: Props) => {
  const { company } = useCurrentSession()
  const { loading, data } = useQuery(ProjectLogDocument, {
    variables: { companyId: company.id, featureIds: [Features.projects_logs] },
  })

  const isProjectLogFeatureAvailable =
    !!data?.companies.featureAvailabilitiesConnection.nodes[0]?.available

  return (
    <ActivityLogSidepanel
      identifier={IDENTIFIER}
      parentResourceId={id}
      updatesTitle={name}
      onClose={onClose}
      loading={loading}
      filteredSources={SOURCE_OPTIONS()}
      upgradeElement={
        !isProjectLogFeatureAvailable && (
          <MissingFeatureEmptyState
            featureRequested={Features.projects_logs}
            requestSource={ProjectsUpsellRequestSources.projectLog}
            learnMoreNavigate={{
              url: 'https://help.factorialhr.com/tasks-projects',
              isExternal: true,
            }}
            description={i18n.t('project_management.upselling.activity_log')}
            variant="table"
          />
        )
      }
    />
  )
}
